import Edit from './Edit';
import List from './List';

export {
    List,
    Edit,
};
